module.exports = __webpack_public_path__ + "static/img/hunde.5c19db7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cranio-auswahl/hunde.jpg
// module id = dZGj
// module chunks = 0